module.exports = __webpack_public_path__ + "static/media/pic-3.3532dea0.jpg";